import PropTypes from 'prop-types';
import React from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import AppColor from 'utilities/AppColor';

const AppSelect = (props) => {
  const {
    isNotMargin,
    onChange,
    name, placeholder, options,
    className,
    value,
    allowOverflow = false,
    isNotClearable = false,
    defaultValue,
    onMenuScrollToBottom
  } = props;
  
  const { t } = useTranslation();

  return (
    <Select
      name={name}
      placeholder={t(placeholder)}
      isClearable={!isNotClearable}
      options={options}
      className={className}
      value={value}
      defaultValue={defaultValue}
      onMenuScrollToBottom={onMenuScrollToBottom}
      menuPosition="fixed"
      menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
      styles={{
        menuPortal: base => ({ ...base, zIndex: 9999 }),
        container: (base) => ({
          ...base,
          margin: isNotMargin ? 0 : '0.3rem 0',
          zIndex: 1000
        }),
        control: (base) => ({
          ...base,
          borderColor: AppColor.mainColor,
          boxShadow: '0 4px 4px rgb(0 0 0 / 25%)',
          minHeight: 40,
          '&:hover': {
            borderColor: AppColor.mainColor,
            boxShadow: `0 0 0 1px ${AppColor.mainColor}`
          },
          '&:focus': {
            borderColor: AppColor.mainColor,
            boxShadow: `0 0 0 1px ${AppColor.mainColor}`
          }
        }),
        option: (styles, { isDisabled, isSelected }) => {
          return {
            ...styles,
            backgroundColor: isSelected ? `${AppColor.mainColor}!important` : isDisabled ? '#f3f3f3' : AppColor.white,
            opacity: isDisabled ? 0.5 : 1,
            color: isSelected ? AppColor.white : AppColor.black,
            cursor: isDisabled ? 'not-allowed' : 'default',
            '&:active': {
              backgroundColor: AppColor.mainLight
            },
            '&:hover': {
              backgroundColor: AppColor.mainLight
            }
          };
        },
        singleValue: (base) => ({
          ...base,
          position: 'static',
          top: 'auto',
          left: 'auto',
          transform: 'none',
          maxWidth: 'none',
          whiteSpace: allowOverflow ? 'initial' : 'nowrap'
        }),
        valueContainer: (base) => ({
          ...base,
          flexWrap: 'nowrap'
        }),
        placeholder: (base) => ({
          ...base,
          position: 'static',
          top: 'auto',
          left: 'auto',
          transform: 'none',
          maxWidth: 'none'
        })
      }}
      onChange={onChange}
    />
  );
};

AppSelect.propTypes = {
  onChange: PropTypes.func,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  options: PropTypes.any,
  className: PropTypes.any,
  value: PropTypes.any,
  allowOverflow: PropTypes.bool,
  defaultValue: PropTypes.any,
  isNotMargin: PropTypes.bool,
};

export default AppSelect;
